import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageTitleService } from 'app/services/page-title/page-title.service';
import { CodaltComponent } from '../codalt.component';
import { CustomerProject, ProjectAccess } from '../customer-project.interface';
import { CustomerProjectService } from '../services/customer-project/customer-project.service';

@Component({
    selector: 'app-customer-project-request-access',
    templateUrl: './customer-project-request-access.component.html',
    standalone: false,
})
export class CustomerProjectRequestAccessComponent extends CodaltComponent implements OnInit {
    customerId: number;
    projectId: number;
    project: CustomerProject;
    access: ProjectAccess;
    requesting = false;
    projectLink: any[];

    constructor(
        private customerProjectService: CustomerProjectService,
        private pageTitleService: PageTitleService,
        private route: ActivatedRoute
    ) {
        super();
    }

    ngOnInit(): void {
        this.pageTitleService.setTitle('Toegang aanvragen');
        this.watchRouteParams(
            [this.RouteParamnames.customerId, this.RouteParamnames.projectId],
            ({ customerId, projectId }) => {
                this.customerId = +customerId;
                this.projectId = +projectId;
                this.projectLink = [
                    '/',
                    this.Routenames.customers,
                    this.customerId,
                    this.Utils.isDrillingRoute(this.route)
                        ? this.Routenames.drillingProjects
                        : this.Routenames.projects,
                    this.projectId,
                ];
                this.loadAccess();
            }
        );
    }

    private loadAccess() {
        this.subscriptions.add(
            this.customerProjectService.getProjectAccess(this.projectId).subscribe(access => {
                this.access = access;
            })
        );
    }

    requestAccess() {
        this.requesting = true;
        this.subscriptions.add(
            this.customerProjectService.requestProjectAccess(this.projectId).subscribe({
                next: () => {
                    this.requesting = false;
                    this.loadAccess();
                },
                error: () => (this.requesting = false),
            })
        );
    }
}
